module.exports = __webpack_public_path__ + "img/金瓜石.dd550f54.png";